import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ApplicationCard = ({ application, userType }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const statusConfig = {
    pending: { color: 'text-warning', bg: 'bg-warning/10', label: 'Pending' },
    accepted: { color: 'text-success', bg: 'bg-success/10', label: 'Accepted' },
    rejected: { color: 'text-error', bg: 'bg-error/10', label: 'Rejected' },
    completed: { color: 'text-primary', bg: 'bg-primary/10', label: 'Completed' }
  };

  const status = statusConfig?.[application?.status] || statusConfig?.pending;

  return (
    <div className="bg-card rounded-md p-2.5 md:p-6 shadow-warm transition-smooth hover:shadow-warm-md">
      <div className="flex items-start gap-2 md:gap-4 mb-2 md:mb-4">
        <Image
          src={application?.image}
          alt={application?.imageAlt}
          className="w-10 h-10 md:w-16 md:h-16 rounded-md object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-semibold text-sm md:text-lg text-foreground mb-0.5 md:mb-1 line-clamp-1">
            {application?.title}
          </h3>
          <p className="text-xs md:text-base text-muted-foreground mb-1 md:mb-2 line-clamp-1">
            {userType === 'provider' ? application?.clientName : application?.workerName}
          </p>
          <div className="flex flex-wrap items-center gap-1.5 md:gap-3">
            <span className={`px-1.5 py-0.5 md:px-2 md:py-1 rounded-full text-[10px] md:text-xs font-medium ${status?.bg} ${status?.color}`}>
              {status?.label}
            </span>
            <span className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-sm text-muted-foreground">
              <Icon name="MapPin" size={12} className="md:w-[14px] md:h-[14px]" />
              {application?.location}
            </span>
            <span className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-sm font-medium text-foreground">
              <Icon name="DollarSign" size={12} className="md:w-[14px] md:h-[14px]" />
              ₱{application?.rate?.toLocaleString()}/hr
            </span>
          </div>
        </div>
      </div>
      {isExpanded && (
        <div className="pt-2 md:pt-4 border-t border-border space-y-1.5 md:space-y-3">
          <div>
            <p className="text-[10px] md:text-sm font-medium text-foreground mb-0.5 md:mb-1">Cover Letter:</p>
            <p className="text-[10px] md:text-sm text-muted-foreground">{application?.coverLetter}</p>
          </div>
          <div className="flex flex-wrap gap-1.5 md:gap-2">
            <span className="text-[10px] md:text-sm text-muted-foreground">
              <strong>Applied:</strong> {new Date(application.appliedDate)?.toLocaleDateString('en-PH')}
            </span>
            <span className="text-[10px] md:text-sm text-muted-foreground">
              <strong>Availability:</strong> {application?.availability}
            </span>
          </div>
        </div>
      )}
      <div className="flex gap-1.5 md:gap-2 mt-2 md:mt-4">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex-1 px-2 py-1.5 md:px-4 md:py-2.5 rounded-md border border-border text-foreground text-xs md:text-base font-medium hover:bg-muted transition-smooth"
        >
          {isExpanded ? 'Show Less' : 'View Details'}
        </button>
        {application?.status === 'pending' && userType === 'seeker' && (
          <button className="px-2 py-1.5 md:px-4 md:py-2.5 rounded-md bg-primary text-primary-foreground text-xs md:text-base font-medium hover:opacity-90 transition-smooth">
            Review
          </button>
        )}
      </div>
    </div>
  );
};

export default ApplicationCard;